if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = this.resolveCart();
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.upsellVariantId = this.dataset.upsellVariantId;
        this.productInfo = this.closest("product-info");
        this.errorStateChangeTarget = this.productInfo || this.form;
        this.clearErrorOnInputChange = this.clearErrorOnInputChange.bind(this);
        this.errorStateChangeTarget.addEventListener(
          "change",
          this.clearErrorOnInputChange
        );
        this.errorStateChangeTarget.addEventListener(
          "input",
          this.clearErrorOnInputChange
        );

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.nativeFallbackAttempted = false;
      }

      disconnectedCallback() {
        this.errorStateChangeTarget?.removeEventListener(
          "change",
          this.clearErrorOnInputChange
        );
        this.errorStateChangeTarget?.removeEventListener(
          "input",
          this.clearErrorOnInputChange
        );
      }

      resolveCart() {
        const cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        if (
          cart &&
          typeof cart.getSectionsToRender === "function" &&
          typeof cart.renderContents === "function" &&
          typeof cart.setActiveElement === "function"
        ) {
          return cart;
        }

        return null;
      }

      restoreSubmitButton() {
        this.submitButton.classList.remove("loading");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading__spinner")?.classList.add("hidden");
      }

      submitNativeFallback() {
        if (this.nativeFallbackAttempted || !this.form) return;
        this.nativeFallbackAttempted = true;
        // Bypasses the submit event so onSubmitHandler is not re-entered.
        HTMLFormElement.prototype.submit.call(this.form);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.clearErrorState();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        this.cart = this.resolveCart();

        let productAdded = false;

        try {
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          this.skipCart = false;
          const variantInput = this.form.querySelector("[name=id]");
          console.log("Variant input:", variantInput);
          console.log("Variant input dataset:", variantInput?.dataset);
          console.log("Skip cart dataset:", variantInput?.dataset?.skipCart);
          if (variantInput?.dataset?.skipCart === "true") {
            this.skipCart = true;
            console.log("Skip cart enabled");
          }

          fetch(`${routes.cart_url}.js`)
            .then((response) => response.json())
            .then((cartState) => {
              if (cartState.item_count === 0 && this.upsellVariantId) {
                return fetch(
                  `${routes.cart_add_url}`,
                  this.getUpsellProductConfig()
                );
              }
            })
            .then(() => {
              return fetch(`${routes.cart_add_url}`, config);
            })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButtonText.classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              }

              productAdded = true;

              if (this.skipCart) {
                console.log("Redirecting to checkout");
                window.location = "/checkout";
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              this.clearErrorState();
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                });
              this.error = false;

              try {
                const quickAddModal = this.closest("quick-add-modal");
                if (quickAddModal) {
                  document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        try {
                          this.cart.renderContents(response);
                        } catch (renderError) {
                          console.error(renderError);
                          window.location = window.routes.cart_url;
                        }
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }
              } catch (renderError) {
                console.error(renderError);
                // Product already in cart — do not add again.
                window.location = window.routes.cart_url;
              }
            })
            .catch((e) => {
              console.error(e);
              const message =
                (e && e.message) ||
                (window.cartStrings && window.cartStrings.error) ||
                "Error";
              this.handleErrorMessage(message);
              this.restoreSubmitButton();

              if (productAdded) {
                window.location = window.routes.cart_url;
              } else {
                this.submitNativeFallback();
              }
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error) this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");
            });
        } catch (e) {
          console.error(e);
          const message =
            (e && e.message) ||
            (window.cartStrings && window.cartStrings.error) ||
            "Error";
          this.handleErrorMessage(message);
          this.restoreSubmitButton();
          if (!productAdded) {
            this.submitNativeFallback();
          }
        }
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append("id", this.upsellVariantId);
        upsellFormData.append("quantity", 1);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = upsellFormData;

        return config;
      }

      clearErrorOnInputChange(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const shouldClearError = target.matches(
          [
            '[name="id"]',
            '[name="quantity"]',
            ".quantity__input",
            ".bundle-radio",
            "variant-selects select",
            "variant-radios input",
            '.product-form__input input[type="radio"]',
            ".product-form__input select",
          ].join(",")
        );

        if (!shouldClearError) return;
        if (target.form && target.form !== this.form) return;
        if (
          !this.form.contains(target) &&
          target.getAttribute("form") &&
          target.getAttribute("form") !== this.form.id
        )
          return;

        this.clearErrorState();
      }

      clearErrorState() {
        this.error = false;
        this.handleErrorMessage();
        this.submitButton.removeAttribute("aria-disabled");
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading__spinner")?.classList.add("hidden");

        const soldOutMessage =
          this.submitButton.querySelector(".sold-out-message");
        soldOutMessage?.classList.add("hidden");
        this.submitButtonText?.classList.remove("hidden");
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        } else {
          this.errorMessage.textContent = "";
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
